import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const GSTAdvisoryAndCompliance = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        GST Advisory and Compliance Services
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        We provide expert guidance and support to ensure seamless GST
        management, covering advisory insights and compliance solutions tailored
        to your business needs.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Advisory Support */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Advisory Support
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            We offer specialized advisory services on GST, including guidance on
            outward supplies, input tax credit eligibility, valuation methods,
            time and place of supply, and adjustments due to tax rate changes.
            Our team evaluates the impact of these factors on your business
            operations to optimize tax strategies.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Additionally, we provide expert opinions to address complex
            tax-related queries, ensuring informed decision-making and compliance
            with GST regulations.
          </p>

          {/* Compliance Assistance */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Assistance
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Our compliance services include support for GST registration
            processes, preparation and review of GST returns (including refund
            claims), and comprehensive audits of business operations to pinpoint
            opportunities and address compliance gaps.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            We also conduct thorough reviews of your company’s GST
            implementation and prepare annual reconciliation statements,
            aligning GST returns with audited financial statements for accuracy
            and transparency.
          </p>

          {/* Required Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Required Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            To avail our services, clients need to provide business registration
            details, prior GST filings (if any), financial statements, and proof
            of business operations. Additional documents may be requested based
            on specific advisory or compliance needs.
          </p>

          {/* Final Insights */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Final Insights
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Our GST advisory and compliance services are designed to streamline
            your tax obligations, minimize risks, and enhance operational
            efficiency. Partner with us to navigate the complexities of GST with
            confidence.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GSTAdvisoryAndCompliance;